import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";
import "firebase/auth";

export const firebaseConfig = {
	apiKey: "AIzaSyDfR885GwVO8iRZZOcmBHE4m8QI64QcUeo",
	authDomain: "carscoringai.firebaseapp.com",
	projectId: "carscoringai",
	storageBucket: "carscoringai.firebasestorage.app",
	messagingSenderId: "306488218665",
	appId: "1:306488218665:web:36c8b55781b15375cd3838",
};

const app = initializeApp(firebaseConfig);
export const auth = getAuth(app);
